module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-192x192-5fb97aecaaa4b496e80e32a6344a95b8.png";